<template lang="pug">
div
  page-title(title="DentalGO Afiliados" icon="fas fa-tachometer-alt" subtitle="Tela inicial contendo o seu desempenho")
  .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
  div(v-else-if="!error && dashboard")
    boxes.mb-2(:value="dashboard.boxes")
    .columns
      .column.col-6.col-md-12.mb-2.pb-2
        chart-gain(:value="dashboard.charts.gain")
      .column.col-6.col-md-12.mb-2.pb-2
        chart-resume(:value="dashboard.charts.resume")
  error-box(v-else-if="error" :error="error")
</template>

<script>
import Boxes from './filiated/Boxes'
import ChartGain from './filiated/ChartGain'
import ChartResume from './filiated/ChartResume'
import home from '@/services/api/home'

export default {
  data() {
    return { loading: false, dashboard: null, error: null }
  },
  components: { Boxes, ChartGain, ChartResume },
  methods: {
    async fetchDashboard() {
      try {
        this.loading = true
        const { data } = await home.dashboard()
        const { charts, ...boxes } = data
        this.dashboard = { charts, boxes }
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchDashboard()
  },
}
</script>
